import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import * as fromAuth from '../store/auth';
import { AuthService } from '../services';
import { ExpiredPermissionUiStatic } from '@app/features/expired-permission-ui/expired-permission-ui.static';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private store: Store<fromAuth.AuthState>,
		private authService: AuthService) {
	}

	canActivate(): Observable<boolean> {

		return this.store.pipe(
			select(fromAuth.getLoggedIn),
			map((authed) => {
				if (!authed) {
					this.store.dispatch(new fromAuth.LoginRedirect('/dashboard'));
					return false;
				}

				return true;
			}),
			take(1),
		);
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const activeToken = this.authService.getActiveToken();

		if (Object.is(activeToken, true)) {
			return activeToken;
		} else {
			ExpiredPermissionUiStatic.open();
			return activeToken;
		}
	}
}
